import { getApiErrorCode } from './apiErrorCode';

const readDetail = (error, key) => {
  const data = error?.response?.data;
  if (!data || typeof data !== 'object') {
    return undefined;
  }

  const nested = data.payload || data.details || data.Payload || data.Details || {};
  return data[key] ?? data[key.charAt(0).toUpperCase() + key.slice(1)] ?? nested[key]
    ?? nested[key.charAt(0).toUpperCase() + key.slice(1)];
};

export const STOCK_ERROR_KEYS = {
  InsufficientStock: 'stock.errors.insufficient',
  ProductNotSellable: 'stock.errors.notSellable',
  StockUnitChangeNotAllowed: 'stock.errors.unitLocked',
  StockPurchaseNotFound: 'stock.errors.purchaseNotFound',
  StockPurchaseAlreadyVoided: 'stock.errors.purchaseVoided',
  SupplierNotFound: 'stock.errors.supplierNotFound',
  SupplierArchived: 'stock.errors.supplierArchived',
  ExpenseNotFound: 'expenses.errors.notFound',
  ExpenseReadOnly: 'expenses.errors.readOnly',
  ExpenseRecurrenceInvalid: 'expenses.errors.recurrenceInvalid',
  ExpenseEditScopeInvalid: 'expenses.errors.scopeInvalid',
  ServiceRecipeInvalid: 'stock.errors.recipeInvalid',
};

export const describeInsufficientStock = (error, t) => {
  if (getApiErrorCode(error) !== 'InsufficientStock') {
    return null;
  }

  const available = readDetail(error, 'available');
  if (available == null || available === '') {
    return t('stock.errors.insufficient');
  }

  return t('stock.errors.onlyNLeft', { count: Number(available) });
};

export const describeApiError = (error, t, fallbackKey) => {
  const stockMessage = describeInsufficientStock(error, t);
  if (stockMessage) {
    return stockMessage;
  }

  const code = getApiErrorCode(error);
  const key = STOCK_ERROR_KEYS[code];
  if (key) {
    return t(key);
  }

  return fallbackKey ? t(fallbackKey) : null;
};
